import illustratorBasicsImg from "./Images/illustrator/image4.png";
import illustratorToolsImg from "./Images/illustrator/image5.png";

import photoshopBasicsImg from "./Images/photoshop-basics.png";
import photoshopToolsImg from "./Images/photoshop-tools.png";

import animateBasicsImg from "./Images/instructions.png";
import animateToolsImg from "./Images/frames.png";

import afterEffectsBasicsImg from "./Images/AE/image4.png";
import afterEffectsToolsImg from "./Images/AE/image5.png";

import xdBasicsImg from "./Images/xd/image4.png";
import xdToolsImg from "./Images/xd/image5.png";

import canvaBasicsImg from "./Images/canva/image4.png";
import canvaToolsImg from "./Images/canva/image5.png";

import splineBasicsImg from "./Images/spline/image4.png";
import splineToolsImg from "./Images/spline/image5.png";

import procreateBasicsImg from "./Images/procreate/image4.png";
import procreateToolsImg from "./Images/procreate/image5.png";

import procreateDreamsBasicsImg from "./Images/dreams/image4.png";
import procreateDreamsToolsImg from "./Images/dreams/image5.png";

import figmaBasicsImg from "./Images/figma/image4.png";
import figmaToolsImg from "./Images/figma/image5.png";

import illustratorGuideImage from "./Images/illustrator/image3.png";
import photoshopGuideImage from "./Images/header-photoshop.png";
import animateGuideImage from "./Images/header-animate.png";
import afterEffectsGuideImage from "./Images/AE/image3.png";
import xdGuideImage from "./Images/xd/image3.png";
import canvaGuideImage from "./Images/canva/image3.png";
import splineGuideImage from "./Images/spline/image3.png";
import procreateGuideImage from "./Images/procreate/image3.png";
import procreateDreamsGuideImage from "./Images/dreams/image3.png";
import figmaGuideImage from "./Images/figma/image3.png";

export const toolGuidesData = {
  "adobe-illustrator": {
    title: "Your Guide to Adobe Illustrator",
    style: "Illustration",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Adobe Illustrator Guide! This guide will help you get started with Adobe Illustrator, a powerful tool for creating vector graphics and illustrations. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: illustratorGuideImage,
    sections: [
      {
        title: "1. Getting Started with Adobe Illustrator",
        content: [
          {
            title: "Introduction to Adobe Illustrator",
            description:
              "Adobe Illustrator is a versatile tool that allows you to create vector graphics for various platforms. It’s ideal for creating logos, illustrations, and other design elements.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Adobe Illustrator and select 'File > New'. Choose a canvas size and frame size suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: illustratorBasicsImg,
      },
      {
        title: "2. Basic Drawing and Animation Tools",
        content: [
          {
            title: "Drawing Tools",
            description:
              "Select and manipulate objects with the Selection Tool. Draw with the Pen Tool, and create shapes with the Shape Tools.",
          },
          {
            title: "Creating Simple Animations",
            description:
              "Learn the basics of creating frame-by-frame animations and using the timeline to animate objects.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple ball animation: Draw a circle using the Shape Tool, add keyframes on the timeline, move the circle, and create a motion tween.",
          },
        ],
        image: illustratorToolsImg,
      },
    ],
  },
  "adobe-photoshop": {
    title: "Your Guide to Adobe Photoshop",
    style: "Editing",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Adobe Photoshop Guide! This guide will help you get started with Adobe Photoshop, a powerful tool for editing photos and creating digital artwork. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: photoshopGuideImage,
    sections: [
      {
        title: "1. Getting Started with Adobe Photoshop",
        content: [
          {
            title: "Introduction to Adobe Photoshop",
            description:
              "Adobe Photoshop is a versatile tool that allows you to edit photos and create digital artwork. It’s ideal for photo retouching, compositing, and graphic design.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Adobe Photoshop and select 'File > New'. Choose a canvas size and resolution suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: photoshopBasicsImg,
      },
      {
        title: "2. Basic Editing Tools",
        content: [
          {
            title: "Selection Tools",
            description:
              "Select and manipulate parts of your image with the Selection Tools. Use the Marquee, Lasso, and Magic Wand tools to make selections.",
          },
          {
            title: "Creating Layers",
            description:
              "Learn how to create and manage layers to organize your artwork. Use layer masks to apply non-destructive edits.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple photo composite: Open two images, use the Selection Tools to cut out a part of one image, and paste it into the other image. Adjust the layers and apply a layer mask to blend the images.",
          },
        ],
        image: photoshopToolsImg,
      },
    ],
  },
  "adobe-animate": {
    title: "Your Guide to Adobe Animate",
    style: "Animation",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Adobe Animate Guide! This guide will help you get started with Adobe Animate, a powerful tool for creating interactive animations and multimedia content. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: animateGuideImage,
    sections: [
      {
        title: "1. Getting Started with Adobe Animate",
        content: [
          {
            title: "Introduction to Adobe Animate",
            description:
              "Adobe Animate is a versatile tool that allows you to create interactive animations for web, games, and TV shows. It’s ideal for creating 2D animations and interactive content.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Adobe Animate and select 'File > New'. Choose a canvas size and frame rate suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: animateBasicsImg,
      },
      {
        title: "2. Basic Drawing and Animation Tools",
        content: [
          {
            title: "Drawing Tools",
            description:
              "Select and manipulate objects with the Selection Tool. Draw with the Brush Tool, and create shapes with the Rectangle Tool.",
          },
          {
            title: "Creating Simple Animations",
            description:
              "Learn the basics of creating frame-by-frame animations and using the timeline to animate objects.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple ball animation: Draw a circle using the Brush Tool, add keyframes on the timeline, move the circle, and create a motion tween.",
          },
        ],
        image: animateToolsImg,
      },
    ],
  },
  "after-effects": {
    title: "Your Guide to Adobe After Effects",
    style: "Editing",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Adobe After Effects Guide! This guide will help you get started with Adobe After Effects, a powerful tool for creating motion graphics and visual effects. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: afterEffectsGuideImage,
    sections: [
      {
        title: "1. Getting Started with Adobe After Effects",
        content: [
          {
            title: "Introduction to Adobe After Effects",
            description:
              "Adobe After Effects is a versatile tool that allows you to create motion graphics and visual effects for video, web, and film. It’s ideal for creating animations, titles, and visual effects.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Adobe After Effects and select 'File > New'. Choose a composition size and frame rate suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: afterEffectsBasicsImg,
      },
      {
        title: "2. Basic Animation and Effects Tools",
        content: [
          {
            title: "Animation Tools",
            description:
              "Create keyframe animations to move and transform objects. Use the Graph Editor to fine-tune your animations.",
          },
          {
            title: "Applying Effects",
            description:
              "Learn how to apply and customize effects to enhance your animations. Use the Effects & Presets panel to find and apply effects.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple text animation: Create a text layer, add keyframes to animate the text position, and apply an effect to create a fade-in animation.",
          },
        ],
        image: afterEffectsToolsImg,
      },
    ],
  },
  "adobe-xd": {
    title: "Your Guide to Adobe XD",
    style: "UX/UI",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Adobe XD Guide! This guide will help you get started with Adobe XD, a powerful tool for designing and prototyping user experiences. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: xdGuideImage,
    sections: [
      {
        title: "1. Getting Started with Adobe XD",
        content: [
          {
            title: "Introduction to Adobe XD",
            description:
              "Adobe XD is a versatile tool that allows you to design and prototype user experiences for web and mobile applications. It’s ideal for creating wireframes, mockups, and interactive prototypes.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Adobe XD and select 'File > New'. Choose a device size and orientation suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: xdBasicsImg,
      },
      {
        title: "2. Basic Design and Prototyping Tools",
        content: [
          {
            title: "Design Tools",
            description:
              "Use the Rectangle, Ellipse, and Polygon tools to create shapes. Use the Text tool to add and style text.",
          },
          {
            title: "Creating Prototypes",
            description:
              "Learn how to create interactive prototypes by linking artboards and adding transitions. Use the Preview panel to test your prototypes.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple interactive prototype: Create multiple artboards, add elements to each artboard, and link the artboards to create navigation.",
          },
        ],
        image: xdToolsImg,
      },
    ],
  },
  canva: {
    title: "Your Guide to Canva",
    style: "Editing",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Canva Guide! This guide will help you get started with Canva, a powerful online tool for creating graphics and marketing materials. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: canvaGuideImage,
    sections: [
      {
        title: "1. Getting Started with Canva",
        content: [
          {
            title: "Introduction to Canva",
            description:
              "Canva is a versatile online tool that allows you to create graphics for social media, presentations, posters, and more. It’s ideal for creating professional-quality designs with ease.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Canva and select 'Create a Design'. Choose a template or custom dimensions suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: canvaBasicsImg,
      },
      {
        title: "2. Basic Design Tools",
        content: [
          {
            title: "Design Tools",
            description:
              "Use the Elements panel to add shapes, lines, and illustrations. Use the Text panel to add and style text.",
          },
          {
            title: "Creating Graphics",
            description:
              "Learn how to create eye-catching graphics by combining elements, text, and images. Use the Background panel to add colors and patterns.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a social media graphic: Select a template, customize the text and elements, and download your design.",
          },
        ],
        image: canvaToolsImg,
      },
    ],
  },
  spline: {
    title: "Your Guide to Spline",
    style: "3D Design",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Spline Guide! This guide will help you get started with Spline, a powerful tool for creating 3D designs and animations. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: splineGuideImage,
    sections: [
      {
        title: "1. Getting Started with Spline",
        content: [
          {
            title: "Introduction to Spline",
            description:
              "Spline is a versatile tool that allows you to create 3D designs and animations for web and mobile applications. It’s ideal for creating interactive 3D content.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Spline and select 'File > New'. Choose a canvas size and frame rate suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: splineBasicsImg,
      },
      {
        title: "2. Basic 3D Design Tools",
        content: [
          {
            title: "3D Design Tools",
            description:
              "Use the Shape and Text tools to create 3D objects. Use the Transform tools to move, rotate, and scale objects.",
          },
          {
            title: "Creating Animations",
            description:
              "Learn how to create animations by adding keyframes and adjusting object properties. Use the Timeline panel to manage your animations.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple 3D animation: Create a 3D object, add keyframes to animate the object, and preview your animation.",
          },
        ],
        image: splineToolsImg,
      },
    ],
  },
  procreate: {
    title: "Your Guide to Procreate",
    style: "Illustration",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Procreate Guide! This guide will help you get started with Procreate, a powerful tool for creating digital illustrations. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: procreateGuideImage,
    sections: [
      {
        title: "1. Getting Started with Procreate",
        content: [
          {
            title: "Introduction to Procreate",
            description:
              "Procreate is a versatile tool that allows you to create digital illustrations on the iPad. It’s ideal for creating sketches, paintings, and illustrations.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Procreate and select 'File > New'. Choose a canvas size and resolution suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: procreateBasicsImg,
      },
      {
        title: "2. Basic Drawing Tools",
        content: [
          {
            title: "Drawing Tools",
            description:
              "Use the Brush and Pencil tools to create digital artwork. Use the Smudge and Eraser tools to refine your work.",
          },
          {
            title: "Creating Layers",
            description:
              "Learn how to create and manage layers to organize your artwork. Use layer masks to apply non-destructive edits.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple illustration: Create a new canvas, sketch your design with the Pencil tool, and add color with the Brush tool.",
          },
        ],
        image: procreateToolsImg,
      },
    ],
  },
  "procreate-dreams": {
    title: "Your Guide to Procreate Dreams",
    style: "Animation",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Procreate Dreams Guide! This guide will help you get started with Procreate Dreams, a powerful tool for creating animations and interactive content. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: procreateDreamsGuideImage,
    sections: [
      {
        title: "1. Getting Started with Procreate Dreams",
        content: [
          {
            title: "Introduction to Procreate Dreams",
            description:
              "Procreate Dreams is a versatile tool that allows you to create animations and interactive content on the iPad. It’s ideal for creating 2D animations and interactive experiences.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Procreate Dreams and select 'File > New'. Choose a canvas size and frame rate suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: procreateDreamsBasicsImg,
      },
      {
        title: "2. Basic Animation Tools",
        content: [
          {
            title: "Animation Tools",
            description:
              "Use the Timeline and Keyframe tools to create animations. Use the Transform tools to move, rotate, and scale objects.",
          },
          {
            title: "Creating Interactive Content",
            description:
              "Learn how to create interactive content by adding triggers and actions. Use the Preview panel to test your interactive content.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple animation: Create a new canvas, draw a series of frames to create an animation, and preview your animation.",
          },
        ],
        image: procreateDreamsToolsImg,
      },
    ],
  },
  figma: {
    title: "Your Guide to Figma",
    style: "UX/UI",
    mention: "Let's Get Started!",
    description:
      "Welcome to the Figma Guide! This guide will help you get started with Figma, a powerful tool for designing and prototyping user experiences. Whether you're a beginner or looking to refine your skills, this guide covers the basics to set you on the right path.",
    image: figmaGuideImage,
    sections: [
      {
        title: "1. Getting Started with Figma",
        content: [
          {
            title: "Introduction to Figma",
            description:
              "Figma is a versatile tool that allows you to design and prototype user experiences for web and mobile applications. It’s ideal for creating wireframes, mockups, and interactive prototypes.",
          },
          {
            title: "Creating a New Project",
            description:
              "Open Figma and select 'File > New'. Choose a device size and orientation suitable for your project. Click 'Create' to open a new project.",
          },
        ],
        image: figmaBasicsImg,
      },
      {
        title: "2. Basic Design and Prototyping Tools",
        content: [
          {
            title: "Design Tools",
            description:
              "Use the Rectangle, Ellipse, and Polygon tools to create shapes. Use the Text tool to add and style text.",
          },
          {
            title: "Creating Prototypes",
            description:
              "Learn how to create interactive prototypes by linking frames and adding transitions. Use the Preview panel to test your prototypes.",
          },
          {
            title: "Try it Out",
            description:
              "Follow these steps to create a simple interactive prototype: Create multiple frames, add elements to each frame, and link the frames to create navigation.",
          },
        ],
        image: figmaToolsImg,
      },
    ],
  },
};
